//@ts-nocheck
import { Box, Image, Spacer, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { FC, useRef, useState } from 'react'
import { Dimensions, ScrollView } from 'react-native'
import Footer from '../../comps/Footer'
import { ImageLoopAnimation } from '../../comps/ImageLoopAnimation'
import { staticStrings } from '../../static/staticStrings'
import useFontSize from '../../util/useFontSize'
import usePadding from '../../util/usePadding'
import { isMobileWidth, isTabletWidth, useWindowDimensions } from '../../util/util'
import { Devices } from './Devices'
import { ExploreProductsSection } from './ExploreProductsSection'
import { HomeContainer } from './HomeContainer'
import { ProductsTab } from './ProductsTab'
import { StatisticsHome } from './StatisticsHome'
import { styles } from './styles'
import { WhyJioHomeSection } from './WhyJioHomeSection'

const ImageBusiness = require('../../assets/svg/business.svg')
const ImageDeveloper = require('../../assets/svg/dev.svg')

const Home: FC = () => {
  const viewPortWidth = useWindowDimensions()
  const refHeight = useRef(Dimensions.get('window').height)
  const resPadding = usePadding()
  const { headerSize, textSize } = useFontSize()
  const themedStyle = styles(viewPortWidth, resPadding)
  const isMobile = isMobileWidth(viewPortWidth)
  const isTab = isTabletWidth(viewPortWidth)
  const navigation = useNavigation()

  const merchantsLogo = require('../../assets/images/merchant-logos-c.png')
  const borderRadius = viewPortWidth > 600 ? 72 : 24

  const [offset, setOffset] = useState(-1)
  const [jioBizzOffset, setJioBizzOffset] = useState(-1)
  const scrollOffsetRef = useRef(-1)
  const scrollOffset = scrollOffsetRef.current
  const [stickyProductVisible, setStickyTabVisible] = useState(false)
  const pgProductKeys = ['pg', 'pos', 'upihub', 'biller', 'jiobizz']

  const [deviceOffset, setDeviceOffset] = useState(-1)
  const [deviceHeight, setDeviceHeight] = useState(-1)
  const [expandAnimation, setExpandAnimation] = useState(false)
  const [collapseAnimation, setCollapseAnimation] = useState(false)
  const time = useRef(Date.now())

  const isInViewport = () => {
    const highlightedComp = pgProductKeys.findIndex((item: any) => {
      const el = document?.getElementById(item)
      const rect = el?.getBoundingClientRect()
      if (!rect) {
        return false
      }
      return rect.top >= 0 && rect.top <= refHeight.current / 2
    })
    highlightedComp != -1 && setSelectedIndex(highlightedComp ?? 0)
  }

  const handleDeviceAnimation = (evt: any, isMovingUp: boolean) => {
    if (isMovingUp) {
      if (
        !expandAnimation &&
        deviceOffset + deviceHeight / 2 - evt?.nativeEvent?.contentOffset?.y <=
          evt?.nativeEvent?.layoutMeasurement?.height &&
        deviceOffset + deviceHeight / 2 - evt?.nativeEvent?.contentOffset?.y >
          evt?.nativeEvent?.layoutMeasurement?.height / 2
      ) {
        setExpandAnimation(true)
        setCollapseAnimation(false)
      }
      const bufferVal = isMobile ? 0 : deviceHeight
      if (!collapseAnimation && deviceOffset + bufferVal - evt?.nativeEvent?.contentOffset?.y < 0) {
        setExpandAnimation(false)
      }
    } else {
      if (!expandAnimation && evt?.nativeEvent?.contentOffset?.y <= 300) {
        setCollapseAnimation(true)
        setExpandAnimation(false)
        return
      } else {
        setCollapseAnimation(false)
        setExpandAnimation(false)
      }
      if (
        !collapseAnimation &&
        deviceOffset + deviceHeight / 2 - evt?.nativeEvent?.contentOffset?.y <=
          evt?.nativeEvent?.layoutMeasurement?.height &&
        deviceOffset + deviceHeight - evt?.nativeEvent?.contentOffset?.y <
          evt?.nativeEvent?.layoutMeasurement?.height / 2
      ) {
        setCollapseAnimation(false)
      } else {
        setExpandAnimation(false)
        setCollapseAnimation(false)
      }
    }
  }

  const onScroll = (evt: any) => {
    if (evt?.nativeEvent?.contentOffset?.y + 100 >= offset && evt?.nativeEvent?.contentOffset?.y <= jioBizzOffset) {
      setStickyTabVisible(true)
      isInViewport()
    } else {
      setStickyTabVisible(false)
    }
    if (scrollOffset === evt?.nativeEvent?.contentOffset?.y) {
      return
    }
    const isMovingUp = evt?.nativeEvent?.contentOffset?.y - scrollOffset > 0

    handleDeviceAnimation(evt, isMovingUp)
    scrollOffsetRef.current = evt?.nativeEvent?.contentOffset?.y
  }

  const onLayout = (evt: any) => {
    offset < 0 && setOffset(evt?.nativeEvent?.layout?.top)
  }

  const onJioBizzLayout = (evt: any) => {
    offset < 0 && setJioBizzOffset(evt?.nativeEvent?.layout?.top)
  }

  const [selectedIndex, setSelectedIndex] = useState(0)

  const landing_mportal_pg = require('../../assets/images/landing_mportal_pg.png')
  const landing_pos = require('../../assets/images/pos.png')
  const upiHub = require('../../assets/images/one-qr-jiopay.png')
  const billerCenter = require('../../assets/images/biller-center.png')
  const jiobizz = require('../../assets/images/jiopaybizz-bg.png')

  return (
    <Box {...themedStyle.container}>
      {stickyProductVisible && !isMobile && (
        <Box ph={resPadding} pb={-120}>
          <ProductsTab selectedIndex={selectedIndex} />
        </Box>
      )}
      <ScrollView onScroll={onScroll} scrollEnabled={true} scrollEventThrottle={16}>
        <Box
          w={'100%'}
          bg={'WHITE'}
          borderTopRightRadius={borderRadius}
          borderTopLeftRadius={borderRadius}
          pv={isMobile ? 56 : 110}
          pb={isMobile ? undefined : 180}>
          <Box ph={resPadding}>
            <ExploreProductsSection isMobile={isMobile} isTab={isTab} />
          </Box>
          {isMobile && <ImageLoopAnimation src={require('../../assets/images/merchant-logos-c.png')} />}
          {!isMobile && (
            <Box ph={isMobile ? undefined : 1.8 * resPadding} align={'center'} pv={40} justify={'center'}>
              <Image resizeMode={'cover'} source={merchantsLogo} width={'100%'} height={64} />
            </Box>
          )}
          <Devices
            isMobile={isMobile}
            isTab={isTab}
            collapseAnimation={collapseAnimation}
            expandAnimation={expandAnimation}
            setDeviceOffset={setDeviceOffset}
            setDeviceHeight={setDeviceHeight}
          />
        </Box>
        <StatisticsHome isMobile={isMobile} />
        <Box
          marginTop={-120}
          nativeID={'products'}
          bg={'WHITE'}
          borderTopRightRadius={isMobile ? 32 : 120}
          borderTopLeftRadius={isMobile ? 32 : 120}
          pv={isMobile ? 80 : 160}>
          <Box ph={resPadding}>
            <Text title={'Our Products'} fontFamily={'jiotype-black'} fontSize={headerSize} />
          </Box>
          <Spacer size={isMobile ? 16 : 32} />
          <Box pr={isMobile ? resPadding : 3 * resPadding} pl={resPadding}>
            <Text
              title={staticStrings.ourProductsLabel}
              fontFamily={'jiotype-medium'}
              fontSize={textSize}
              color={'BLACK_21'}
              opacity={0.9}
              lineHeight={isMobile ? 20 : 32}
            />
          </Box>
          <Spacer size={80} />
          {!stickyProductVisible && !isMobile ? (
            <Box ph={resPadding}>
              <ProductsTab onLayout={onLayout} selectedIndex={selectedIndex} />
            </Box>
          ) : (
            <Box h={-105} />
          )}
          <HomeContainer
            title={'Payment Gateway'}
            imgUrl={landing_mportal_pg}
            subTitle={staticStrings.pgPara}
            labels={[
              'Safe and secure transactions',
              'Popular payment modes',
              'Optimized for web and mobile',
              'Increase conversion',
            ]}
            navigateTo={'paymentgateway'}
            type={'pg'}
          />
          <HomeContainer
            title={'Point Of Sale'}
            imgUrl={landing_pos}
            subTitle={staticStrings.posPara}
            labels={['Accept payments', 'Generate UPI QRs', 'Design campaigns', 'Critical insights']}
            navigateTo={'pointofsale'}
            direction={'row-reverse'}
            type={'pos'}
          />
          <HomeContainer
            title={'UPI Hub'}
            imgUrl={upiHub}
            subTitle={staticStrings.upiHubPara}
            labels={['Accept payments', 'Generate UPI QRs', '1 QR', 'Payment links']}
            navigateTo={'upi'}
            type={'upihub'}
          />
          <HomeContainer
            title={'Biller Center'}
            imgUrl={billerCenter}
            subTitle={staticStrings.billerPara}
            labels={['Collect payments', 'Easy Operations', 'Superior Reach', 'Send payment links']}
            navigateTo={'biller'}
            type={'biller'}
          />
          <HomeContainer
            title={'JioPay Business App'}
            imgUrl={jiobizz}
            subTitle={staticStrings.simpleInstantUpi}
            labels={['Offline Payments', 'Auto Reconciliation & Settlement', '1 QR', 'Transaction Summary']}
            navigateTo={'jio-pay-business'}
            type={'jiobizz'}
            onLayout={onJioBizzLayout}
          />
        </Box>
        <Box marginTop={isMobile ? -12 : -120}>
          <WhyJioHomeSection />
        </Box>
        <Spacer size={isMobile ? 0 : 40} />
        <Box
          mt={isMobile ? -40 : -120}
          borderTopLeftRadius={isMobile ? 32 : 80}
          borderTopRightRadius={isMobile ? 32 : 80}
          bg={'WHITE'}
          zIndex={100}>
          <Footer />
        </Box>
      </ScrollView>
    </Box>
  )
}

export default Home
